import Vue from 'vue'

import { LOCALES } from '@/lang/config'

const STORAGE_KEY = 'settings'

// All settings used in the app should have a default set here.
const defaults = {
  userLanguage: LOCALES.DE,
  cookiesAccepted: false,
  companyUuid: null, // used by the selects for filtering
  projectUuids: [],
}

let saved = {}
try {
  // saved in browser
  const settingsString = localStorage.getItem(STORAGE_KEY)
  saved = JSON.parse(settingsString)
} catch {
  // In case something goes wrong with the json parsing we just use the defaults
}

const settings = new Vue({
  data: Object.assign({}, defaults, saved),
})

const mapSetting = key => ({
  get() {
    return settings[key]
  },
  set(value) {
    settings[key] = value

    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings._data))
  },
})

// This is how settings should be used exclusively. Map the settings you want to use in the component in the computed properties and they will be usable with a getter and setter.
//
// ```
// computed: { ...mapSettings(['some']) },
// methods: {
//   updateSome() {
//     // Will update reactively and be stored in localStorage
//     this.some = 'thing'
//   }
// }
// ```
export const mapSettings = keys => {
  keys.forEach(key => {
    if (!Object.keys(defaults).includes(key)) {
      console.warn(`Tried to map setting "${key}", which does not have a default set.`)
    }
  })

  return Object.fromEntries(keys.map(key => [key, mapSetting(key)]))
}
